// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"blog-breadcrumb_breadcrumb__S4m_Z"};